// @ts-nocheck
import { configureStore } from '@reduxjs/toolkit';
import authSlice from '../services/authSice';
import clearAllSliceReducer from '../services/clearAllMenuslice';
import dashBoardDatesReducer from '../services/dashBoardDatesSlice';
import dishCategoryReducer from '../services/dishcategorySlice';
import ExMenuRequisitionReducer from '../services/exceptionalMenuRequistionSliceParam';
import exmenuRequisitionReducer from '../services/exmenuprojectionslice';
import getCategoryReducer from '../services/getcategorySlice';
import getItemsReducer from '../services/getItemsSlice';
import initiateMenuPlanReportReducer from '../services/InitiateMenuPlanReportSlice';
import itemInitiateMenuPlanReportReducer from '../services/ItemInitiateMenuPlanReportSlice';
import initiateMenuPlanCPUPlannedReportReducer from '../services/InitiateMenuPlanCPUPlannedReportSlice';
import initiateMenuPlanReducer from '../services/InitiateMenuPlanSlice';
import iteamInitiateMenuPlanReducer from '../services/IteamInitiateMenuPlanSlice';
import initiateMenuPlanParamsReducer from '../services/initiateMenuPlanSliceParams';
import kitchenIndentProductionPlanReducer from '../services/kitchenIndentProductionPlanSlice';
import kitchenIndentReducer from '../services/kitchenIndentSlice';
import kitchenParamsReducer from '../services/kitchenParamsSlice';
import initiateMenuProjectionDashboardSliceParams from '../services/menuDashboardParamsSlice';
import dashboardReducer from '../services/menuDashboardSlice';
import menuPlanReducer from '../services/menuPlanSlice';
import menuPlanMrReducer from '../services/menuPlanMrSlice';
import BridgerSliceParamsReducer from '../services/bridgerSliceParam';
import BridgerMenuPlanReducer from '../services/bridgerMenuPlanSlice';
import bridgerMenuSliceReducer from '../services/bridgerMenuSlice';
import initiateMenuProjectionSliceParamsReducer from '../services/menuProjecionParamsSlice';
import ItemInitiateMenuProjectionSliceParamsReducer from '../services/ItemMenuProjecionParamsSlice';
import projecionSelectionParamsReducer from '../services/menuProjecionSelectionParamsSlice';
import projectionSelectionDataReducer from '../services/menuProjectionSelectionDataSlice';
import itemProjecionSelectionParamsReducer from '../services/ItemMenuProjectionSelectionDataSliceParams';
import itemProjectionSelectionDataReducer from '../services/itemProjectionSelectionDataSlice';
import projectionDataReducer from '../services/menuProjectionDataSlice';
import projectionDatesReducer from '../services/menuProjectionDateSlice';
import itemProjectionDataReducer from '../services/ItemMenuProjectionDataSlice';
import itemProjectionDatesReducer from '../services/itemMenuProjectionDateSlice';
import menuRequisitionReducer from '../services/menuRequisitionSlice';
import MenuRequisitionSliceParamsReducer from '../services/menuRequisitionSliceParam';
import ItemMenuRequisitionReducer from '../services/itemMenuRequisitionSlice';
import ItemMenuRequisitionSliceParamsReducer from '../services/ItemMenuRequisitionSliceParam';
import menuReducer from '../services/menuSlice';
import productionPlanReducer from '../services/productionPlanSlice';
import productionPlanReportReducer from '../services/productionPlanReportSlice';
import regionReducer from '../services/regionSlice';
import initiateMenuPlanSliceReducer from '../services/saveCardSlice';
import sectorRegionAllSitesReducer from '../services/sectorRegionAllSitesSlice';
import siteParamsReducer from '../services/siteParamsSlice';
import siteReducer from '../services/siteSlice';
import updateProductionPlanReducer from '../services/updateProductionPlanSlice';
import userReducer from '../services/userSlice';
import sectorRegionAllSitesAdminConfigurationReducer from '../services/sectorRegionAllSitesAdminConfigurationSlice';
import adminConfigurationParamsReducer from '../services/adminConfigurationParamsSlice';
import varianceReportReducer from '../services/varianceReportSlice';
import mapOtherDishesReducer from '../services/mapOtherDishesSlice';
import itemMasterReducer from '../services/itemMasterSlice';
import iteamcategorySlice from '../services/iteamcategorySlice';
import mrEditsReducer, { clearEdits } from './mrEditsSlice';
import nutritionReducer from '../services/nutritionSlice';
import itemMasterCookBookReducer from '../services/itemMasterCookBookSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    user: userReducer,
    menu: menuReducer,
    menuPlan: menuPlanReducer, 
    menuPlanMr: menuPlanMrReducer,
    bridgerMenuPlan: BridgerMenuPlanReducer,
    bridgerPlanParams: BridgerSliceParamsReducer,
    site: siteReducer,
    dishCategory: dishCategoryReducer,
    iteamCategory: iteamcategorySlice,
    saveMenuPlan: initiateMenuPlanSliceReducer,
    getCategory: getCategoryReducer,
    getItems: getItemsReducer,
    InitiateMenuPlan: initiateMenuPlanReducer,
    IteamInitiateMenuPlan: iteamInitiateMenuPlanReducer,
    InitialMenuPlanReport: initiateMenuPlanReportReducer,
    ItemInitiateMenuPlanReport: itemInitiateMenuPlanReportReducer,
    initialMenuCPUPlanReport: initiateMenuPlanCPUPlannedReportReducer,
    InitiateMenuPlanParams: initiateMenuPlanParamsReducer,
    initiateMenuProjectionParams: initiateMenuProjectionSliceParamsReducer,
    ItemInitiateMenuProjectionParams: ItemInitiateMenuProjectionSliceParamsReducer,
    projecionSelectionParams: projecionSelectionParamsReducer,
    itemProjecionSelectionParams: itemProjecionSelectionParamsReducer,
    clearAll: clearAllSliceReducer,
    projectionDates: projectionDatesReducer,
     projectionSelectionData: projectionSelectionDataReducer,
     itemProjectionSelectionData: itemProjectionSelectionDataReducer,
    projectiondatelistitemwise: itemProjectionDatesReducer,
    projectionData: projectionDataReducer,
    itemProjectionData: itemProjectionDataReducer,
    dashboard: dashboardReducer,
    menuDashboardParam: initiateMenuProjectionDashboardSliceParams,
    kitchenIndent: kitchenIndentReducer,
    kitchenIndentProduction: kitchenIndentProductionPlanReducer,
    menuRequisition: menuRequisitionReducer,
    bridgerMenu: bridgerMenuSliceReducer,
    ItemMenuRequisition: ItemMenuRequisitionReducer,
    region: regionReducer,
    productionPlan: productionPlanReducer,
    productionPlanReport: productionPlanReportReducer,
    menuRequisitionParams: MenuRequisitionSliceParamsReducer,
    ItemMenuRequisitionParams: ItemMenuRequisitionSliceParamsReducer,
    sectorRegionAllSitesAdminConfiguration: sectorRegionAllSitesAdminConfigurationReducer,
    kitchenParams: kitchenParamsReducer,
    ExMenuRequisitionParams: ExMenuRequisitionReducer,
    exmenuRequisition: exmenuRequisitionReducer,
    siteParams: siteParamsReducer,
    sectorRegionAllSites: sectorRegionAllSitesReducer,
    updateProductionPlan: updateProductionPlanReducer,
    dashBoardDates:dashBoardDatesReducer,
    adminConfigurationParams:adminConfigurationParamsReducer,
    varianceReport: varianceReportReducer,
    mapOtherDishes: mapOtherDishesReducer,
    itemMaster: itemMasterReducer,
    mrEdits: mrEditsReducer,
    nutrition: nutritionReducer,
     itemMasterCookBook: itemMasterCookBookReducer,
  },
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Ensure MR edits do not persist across page reloads: clear the slice on initial load
// and before the page unloads. This prevents stale UI values after refresh.
if (typeof window !== 'undefined') {
  try {
    // Clear immediately when the store is created (safe no-op if already empty)
    store.dispatch(clearEdits());

    // Also clear on reload/unload
    window.addEventListener('beforeunload', () => {
      try {
        store.dispatch(clearEdits());
      } catch (e) {
        // ignore dispatch errors during unload
      }
    });
  } catch (e) {
    // ignore
  }
}



